/* Copyright (c) Trimble Inc. All rights reserved. */

import { createStyles, makeStyles, Theme } from "@material-ui/core";


export const useDropDownStyles = makeStyles((theme: Theme) =>
  createStyles({
    menu: {
      '& .MuiMenu-list': {
        paddingTop: '0 !important',
      },
    },
    listStyle: {
      padding: 0,
    },
    itemHeader: {
      borderTop: `1px solid ${theme.palette.grey['A400']} !important`,
      '&:hover': {
        backgroundColor: '#DCEDF9 !important',
      },
      color: `${theme.palette.grey['200']} !important`,
      opacity: '1 !important',
      overflowX: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '280px',
      cursor: 'auto !important', // TODO : To be removed as part of Individual team
    },
    contentIcon: {
      paddingRight: '10px',
      marginBottom: '-2px',
      paddingLeft: '15px',
    },
    selectedIcon: {
      fill: `${theme.palette.primary.main} !important`,
    },
    itemBody: {
      '&:hover': {
        backgroundColor: '#DCEDF9 !important',
      },
      overflowX: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '280px',
    },
    expandMoreIcon: {
      color: `${theme.palette.grey['800']} !important`,
    },
    button: {
      borderRadius: '2px',
      border: `1px solid ${theme.palette.grey['A100']} !important`,
      borderBottom: `1px solid ${theme.palette.grey['600']} !important`,
      paddingTop: '18px !important',
      paddingBottom: '18px !important',
      [theme?.breakpoints?.down('sm')]: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '60vw',
        display: 'inline-flex',
        whiteSpace: 'nowrap',
        '& > span': {
          maxWidth: '140px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
        '& > span:first-child':{
          position:'absolute',
          left:'10px',
          paddingRight:'10px'
        },
        '& .MuiButton-endIcon':{
          position:'absolute',
          right:'10px'
        }
      },
    },
    placeholder: {
      color: theme.palette.grey['100'],
      fontWeight: 'normal',
    },
    buttonTextContainer:{
      [theme?.breakpoints?.down('sm')]: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        paddingRight:'20px'
        },
      },
    buttonText: {
      overflowX: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '170px',
      [theme?.breakpoints?.down('sm')]: {
        paddingLeft:'20px'
        },
    },
  })
);

export default useDropDownStyles;
